import { useDispatch } from 'react-redux';
import type { AppDispatch } from './store';

// Use this instead of the plain `useDispatch` in your components
export const useAppDispatch: () => AppDispatch = useDispatch;
